
import "./CloseButtonLowModelOrbit.css"
import { stateIframeWindow, statePlayerPositionS, stateNavigation} from '../store';

const CloseButtonLowModelOrbit = () => {
  

  const handleClose = () => {

    stateIframeWindow.LowModelOrbit = false
    statePlayerPositionS.playerInput = true
    stateNavigation.annotationOverwrite = ""



  };

  return (
    <>
    
       
    
            <button className="closeButtonLowModel" onPointerDown={handleClose}>
            close model view
            </button>
      
      
     
  
    </>
  );
};

export default CloseButtonLowModelOrbit;